import { useState } from "react";
import { Form } from "react-bootstrap";
import { PosTask } from "../../interfaces/Task";
import CustomEditor from "../../elements/CustomEditor";
import Help from "../../elements/HelpContent";
import AITools from "../../elements/AITools";
import { useTranslation } from "react-i18next";
import { Overlay } from "../../elements/Overlay";

const emptyPosTask: any = {
    _id: '0',
    name: '',
    type: 'text',
    instructions: '',
    text: '',
    updated:new Date(),
}

export interface NewPosTaskTextProps {
    saveForm: CallableFunction;
    closeForm: CallableFunction;
    task_language?: string;
}

export default function NewPosTaskText(props: NewPosTaskTextProps) {
    const { t } = useTranslation();
    
    const [postTask, setPosTask] = useState<PosTask>(emptyPosTask);
    const [name, setName] = useState('');
    const [instructions, setInstructions] = useState('');
    const [text, setText] = useState('');
    const [analyzedText, setAnalyzedText] = useState();
    
    const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setName(e.target.value);
    }

    const handleInstructionsChange = (data: string) => {
        setInstructions(data);
    }

    const handleTextChange = (data: string) => {
        setText(data);
    }

    const close = () => {
        props.closeForm();
    }

    const save = () => {
        if (name) {
            postTask.name = name;
            postTask.instructions = instructions;
            postTask.text = text;
            props.saveForm(postTask);
        }
    }

    const handleTextAnalyzed = (data: any) => {
        setAnalyzedText(data);
    }

    const doNothing = () => {
        
    }

    return(
        <Overlay
            title={t("New Post-Task: Text")}
            onClose={close}
            className="new-task-container"
            actions={[
                {
                    label: t("Cancel"),
                    variant: 'secondary',
                    onClick: close
                },
                {
                    label: t("Save"),
                    variant: 'primary',
                    onClick: save
                }
            ]}
        >
            <div className="inner">
                <h2>
                    { t("New Post-Task: Text") }
                    <Help id={ '6520147a1e5cf99991b4e371' } />
                </h2>
                <AITools />
                <Form className="new-post-task-form">
                    <div className="fields-container">
                        <Form.Group className="field field-title">
                            <Form.Label>{ t("Title of the Post-Task") }</Form.Label>
                            <Form.Control type="text" name="name" required value={ name } onChange={ handleNameChange } />
                        </Form.Group>
                        <div className="field field-instructions">
                            <CustomEditor
                                change={ handleInstructionsChange }
                                changeFormatted={ doNothing }
                                data={ postTask.instructions }
                                formatted= { '' }
                                id="instructions"
                                label={ t("Aim and instructions") }
                                npl={ false }
                                task_id={ '' }
                                task_language={ props.task_language }
                            />
                        </div>
                        <div className="field field-text">
                            <CustomEditor
                                change={ handleTextChange }
                                changeFormatted={ doNothing }
                                data={ postTask.text }
                                formatted= { '' }
                                id="text"
                                label={ t("Text")}
                                npl={ false }
                                task_id={ '' }
                                task_language={ props.task_language }
                            />
                        </div>
                    </div>
                </Form>
            </div>
        </Overlay>
    );
}